import * as t from 'io-ts';
import {
  Template,
  Route,
  MySafetyHtmls,
  Offer,
  TopBusesFrom,
  TopOperators,
  LeaveIntentOffer,
  SeoOfferData,
} from '../../../src/pages/runtime-typechecker';

export const CityDataForRoute = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  url: t.string,
  code: t.string,
  cityBoardingPointsList: t.union([t.array(t.string), t.undefined]),
  cityDropPointsList: t.union([t.array(t.string), t.undefined]),
  otherRoutesFrom: t.array(Route),
  otherRoutesTo: t.array(Route),
  cabsRoutes: t.array(Route),
  otherRouteCategories: t.array(Route),
});
export type CityDataForRoute = t.TypeOf<typeof CityDataForRoute>;

export const RouteDataForRouteCategory = t.type({
  sourceCityData: CityDataForRoute,
  destinationCityData: CityDataForRoute,
  topBusesFrom: TopBusesFrom,
  offers: t.union([t.undefined, t.array(Offer)]),
  returnRouteCategoryUrl: t.union([t.string, t.null]),
  topOperatorsList: t.array(TopOperators),
});

export const CategoryData = t.type({
  id: t.number,
  categoryName: t.string,
  friendlyCategoryName: t.string,
});

export const RouteCategoryTemplateDataChecker = t.type({
  id: t.number,
  routeId: t.number,
  categoryId: t.number,
  isActive: t.boolean,
  url: t.string,
  urlPhrase: t.string,
  description: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  routeData: RouteDataForRouteCategory,
  categoryData: CategoryData,
  mySafetyHtmls: MySafetyHtmls,
  offers: t.union([t.array(Offer), t.undefined]),
  status: t.string,
  leaveIntentOffers: t.array(LeaveIntentOffer),
  nearbyCitiesSource: t.array(Route),
  nearbyCitiesDestination: t.array(Route),
  seoOfferData: t.array(SeoOfferData),
  schemaInfo: t.union([t.undefined, t.null, t.string]),
});

export type RouteCategoryData = t.TypeOf<
  typeof RouteCategoryTemplateDataChecker
>;
